<div id="register" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="register-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="/assets/images/logos/logogro.png">
            <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
                <span class="name_title">e</span>.Justicia
            </div>
    
            <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
                Iniciamos una nueva era en la impartición de Justicia Administrativa
            </div>
        </div>

     

    </div>

    <div id="register-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="register-form">

            <div class="logo" fxHide.gt-xs>
                <img src="/assets/images/logos/logogro.png">
            </div>

            <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}" fxHide.gt-xs>
                <span class="name_title">e</span>.Justicia
                <div class="h2 email">Administrativa Durango</div>
            </div>

            <div class="title">
                <div class="h2" *ngIf="!isAdvisorCitizen && !isAuthority">CREA UNA CUENTA</div>
                <!--<div class="h2" *ngIf="isAuthority">CREA UNA CUENTA DE AUTORIDAD</div>
                <div class="h2" *ngIf="isAdvisorCitizen">CREA UNA CUENTA DE PARTE ACTORA</div>
                <div class="h4" *ngIf="isAdvisorCitizen">Asesoría Ciudadana Administrativa en línea</div>-->
            </div>


            <form name="registerForm" [formGroup]="registerForm" novalidate>
                <mat-form-field appearance="outline">
                    <mat-label>Tipo de cuenta a registrar</mat-label>
                    <mat-select formControlName="tUs" required (selectionChange)="setType($event.value)">
                      <mat-option *ngFor="let item of typeUs" [value]="item.nume">
                        {{item.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error>Selecciona un tipo de cuenta</mat-error>
                  </mat-form-field>
                <div *ngIf="registerForm.value.tUs">
                    
                    <mat-form-field appearance="outline" *ngIf="registerForm.value.tUs == 2 ">
                        <mat-label>Folio de registro</mat-label>
                        <input matInput formControlName="folio" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>
                            Folio de registro es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <p class="folio-margin-fix" *ngIf="registerForm.value.tUs == 2 ">
                        Este folio fue proporcionado por la Secretaria de la Junta de Gobierno y Administración del Tribunal de Justicia Administrativa del Estado de Durango, al registrarse el correo electrónico.
                    </p>

                    <mat-form-field appearance="outline" *ngIf="registerForm.value.tUs == 1 || registerForm.value.tUs == 2 ">
                        <mat-label>CURP</mat-label>
                        <input matInput formControlName="curp" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>
                            CURP es obligatoria
                        </mat-error>
                    </mat-form-field>
                   

                    <mat-form-field appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>
                            Nombre es obligatorio
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Apellido Paterno</mat-label>
                        <input matInput formControlName="paterno" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>
                            Apellido paterno es obligatorio
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Apellido Materno</mat-label>
                        <input matInput formControlName="materno" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>
                            Apellido materno es obligatorio
                        </mat-error>
                    </mat-form-field>

                    <div class="file-uploader mt-24" fxLayoutAlign="space-envenly center">

                        <mat-label style="width: 100%; text-align: center;">Añade una identificación oficial
                            <span style="font-size: 20px;" class="material-icons" matTooltip="Credencial para votar vigente (INE), Pasaporte vigente, Cedula profesional con fotografía vigente, Cartilla del servicio militar." matTooltipPosition="above" matTooltipHideDelay="2000">contact_support
                            </span>
                        </mat-label>
                        <br>
                        <input type="file" #ine id="ine" name="ine" style="display:none;" accept="application/pdf" required/>
                        <p style="width: 100%; text-align: center;"><button class="mr-4" mat-raised-button color="info" (click)="setFile('ine')">  
                            <mat-icon>backup</mat-icon>  
                            <span> {{ textBtnUpload }}</span>
                        </button>
                        </p>
                        <div class="attachment-list" *ngIf="registerForm.value.ine !== null && registerForm.value.ine.name !== undefined">
                            <div class="attachment" fxLayout="row" fxLayoutAlign="center center">
                                <div>
                                    <span class="filename">{{ registerForm.value.ine.name }}</span>
                                </div>
                                <!-- <button mat-icon-button aria-label="Delete attachment">
                                    <mat-icon class="s-16" (click)="removeFile('ine')" tooltip="Quitar archivo">close</mat-icon>
                                </button> -->
                            </div>
                        </div>
                        <mat-error *ngIf="registerForm.get('ine').hasError('required')" class="error">{{ txtErrorFileine }}</mat-error>
                        <!-- <mat-hint class="msj-info" align="start" *ngIf="haveIneText !== ''">{{ haveIneText}}</mat-hint> -->
                    </div>
                    <br>
                    <div *ngIf="registerForm.value.tUs == 2"  class="file-uploader mt-24" fxLayoutAlign="space-envenly center">

                        <mat-label style="width: 100%; text-align: center;">Subir nombramiento
                            <span style="font-size: 20px;" class="material-icons" matTooltip="Debes proporcionar el documento correspondiente al nombramiento que te acredite como autoridad y/o representante de la autoridad" matTooltipPosition="above" matTooltipHideDelay="2000">contact_support
                            </span>
                        </mat-label>
                        <br>
                        <input type="file" #nombramiento id="nombramiento" name="nombramiento" style="display:none;" accept="application/pdf" required/>
                        <p style="width: 100%; text-align: center;"><button class="mr-4" mat-raised-button color="info" (click)="setFile('nombramiento')">  
                            <mat-icon>backup</mat-icon>  
                            <span> {{ textBtnUpload }}</span>
                        </button>
                        </p>
                        <div class="attachment-list" *ngIf="registerForm.value.nombramiento !== null && registerForm.value.nombramiento.name !== undefined">
                            <div class="attachment" fxLayout="row" fxLayoutAlign="center center">
                                <div>
                                    <span class="filename">{{ registerForm.value.nombramiento.name }}</span>
                                </div>
                                <!-- <button mat-icon-button aria-label="Delete attachment">
                                    <mat-icon class="s-16" (click)="removeFile('ine')" tooltip="Quitar archivo">close</mat-icon>
                                </button> -->
                            </div>
                        </div>
                        <mat-error *ngIf="registerForm.get('nombramiento').hasError('required')" class="error">{{ txtErrorFileine }}</mat-error>
                        <!-- <mat-hint class="msj-info" align="start" *ngIf="haveIneText !== ''">{{ haveIneText}}</mat-hint> -->
                    </div>
                    <br>

                    <mat-form-field appearance="outline">
                        <mat-label>Teléfono móvil</mat-label>
                        <input matInput type="tel" formControlName="telefono">
                        <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                        <mat-error *ngIf="registerForm.get('telefono').hasError('pattern')">El telefono debe contener solo números</mat-error>
                        <mat-error *ngIf="!registerForm.get('telefono').hasError('pattern') &&
                                        registerForm.get('telefono').hasError('minlength')">El telefono debe contener al menos 10 digitos</mat-error>
                    </mat-form-field>
                    <br>
                    <!--span>Con lo dispuesto en los artículos 25, fracciones I y V, 26, párrafos primero, segundo y séptimo y 26 bis del Código de Procedimientos Administrativos del Estado de México; se señala: (correo electrónico para recibir notificaciones).</span-->
                    <mat-form-field appearance="outline">
                        <mat-label>Correo</mat-label>
                        <input matInput formControlName="email" required>
                        <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                        <mat-error *ngIf="registerForm.get('email').hasError('required')">
                            Correo es obligatorio
                        </mat-error>
                        <mat-error *ngIf="registerForm.get('email').hasError('email')">
                            Por favor ingresa un correo valido
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Contraseña</mat-label>
                        <input matInput type="password" formControlName="password" required>
                        <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                        <mat-error *ngIf="registerForm.get('password').hasError('required')">
                            Contraseña es obligatorio
                        </mat-error>
                        <mat-error *ngIf="!registerForm.get('password').hasError('required') &&
                                        registerForm.get('password').hasError('passwordsNotMatching')">
                            Contraseñas no coinciden
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Confirma Contraseña</mat-label>
                        <input matInput type="password" formControlName="password_confirmation" required>
                        <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                        <mat-error *ngIf="registerForm.get('password_confirmation').hasError('required')">
                            Confirmacion de contraseña es obligatorio
                        </mat-error>
                        <mat-error *ngIf="!registerForm.get('password_confirmation').hasError('required') &&
                                        registerForm.get('password_confirmation').hasError('passwordsNotMatching')">
                            Contraseñas no coinciden
                        </mat-error>
                        <mat-error *ngIf="!registerForm.get('password_confirmation').hasError('required') &&
                                            registerForm.get('password_confirmation').hasError('passwordsNotMatching') &&
                                            registerForm.get('password_confirmation').hasError('minLength')">
                            Contraseñas debe contener 6 o más caracteres
                        </mat-error>
                    </mat-form-field>

                    <div *ngIf="registerForm.value.tUs == 2">
                        <h3>DATOS AUTORIDAD</h3>

                        <mat-form-field appearance="outline">
                            <mat-select formControlName="muni" (selectionChange)="_getNamesList()" required>
                                <mat-option>-- Selecciona uno --</mat-option>
                                <mat-option *ngFor="let item of municipalities" value="{{item.nume}}">{{item.nomb}}</mat-option>
                            </mat-select>
                            <mat-label>
                                Municipio
                            </mat-label>
                            <mat-error>Debes seleccionar un municipio</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-select formControlName="tpau" (selectionChange)="_getNamesList()" required>
                                <mat-option>-- Selecciona uno --</mat-option>
                                <mat-option value="estatal">Estatal</mat-option>
                                <mat-option value="municipal">Municipal</mat-option>
                                <mat-option value="organosautonomos">Órganos autónomos</mat-option>
                                <mat-option value="organosdescentralizados">Órganos descentralizados</mat-option>
                                <mat-option value="particulardemandado">Particular demandado</mat-option>
                                <mat-option value="otro">Otro</mat-option>
                            </mat-select>
                            <mat-label>
                                Tipo Autoridad
                            </mat-label>
                            <mat-error>Debes seleccionar un tipo de autoridad</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Nombre Autoridad</mat-label>
                            <input matInput formControlName="auto" required>
                            <mat-icon matSuffix class="secondary-text">bussiness</mat-icon>
                            <mat-error>
                                Nombre autoridad es obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--mat-form-field class="example-full-width">
                        <mat-label>Assignee</mat-label>
                        <input type="text" matInput [formControl]="auto" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" *ngIf="nameList.length > 0" [displayWith]="displayFn">
                        <mat-option *ngFor="let option of nameList | async" [value]="option">
                            {{option.name}}
                        </mat-option>
                        </mat-autocomplete>
                    </mat-form-field-->


                    <div class="terms" fxLayout="row" fxLayoutAlign="center">
                        <mat-checkbox name="privacity" aria-label="Accept" formControlName="privacity" (click)="validPrivacityChecked()" required>
                            <span style="color: white;">u</span>
                        </mat-checkbox>
                        <span>He leído y estoy de acuerdo con el aviso de privacidad visible
                        <a href="assets/images/file-manager/AVISO_PRIVACIDAD.pdf" target="_blank">aquí</a></span>
                    </div>
                    <mat-error *ngIf="registerForm.get('privacity').hasError('required')">
                        Debes aceptar el aviso de privacidad
                    </mat-error>

                    <mat-error *ngIf="errorMsjRegister != ''" class="error-center mt-24">{{ errorMsjRegister }}</mat-error>

                    <button mat-raised-button color="accent" class="submit-button" aria-label="CREATE AN ACCOUNT" [disabled]="registerForm.invalid || isLoading" (click)="onSubmit()">
                        CREAR CUENTA
                        <div fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
                            <mat-progress-spinner
                                diameter="25"
                                mode="indeterminate">
                            </mat-progress-spinner>
                        </div>
                    </button>
                </div>
                <a mat-stroked-button color="accent" class="submit-button" [disabled]="isLoading" [routerLink]="'/'">
                    CANCELAR
                </a>

            </form>

            <!--div class="register" fxLayout="column" fxLayoutAlign="center center" *ngIf="!isAuthority">
                <span class="text">Soy autoridad</span>
                <a class="link" [routerLink]="'/pages/auth/register/authority'">Crear cuenta</a>
            </div-->

            <!--<div class="register" fxLayout="column" fxLayoutAlign="center center" *ngIf="isAuthority">
                <span class="text">Soy Actor</span>
                <a class="link" [routerLink]="'/pages/auth/register'">Crear cuenta</a>
            </div>-->

            <!--<div class="register" fxLayout="column" fxLayoutAlign="center center" *ngIf="!isAuthority">
                <span class="text">Soy autoridad</span>
                <a class="link" [routerLink]="'/pages/auth/register/authority'">Crear cuenta</a>
            </div>-->

            <div class="register" class="mb-12" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">¿Ya tienes una cuenta?</span>
                <a class="link" [routerLink]="'/pages/auth/login'" *ngIf="!isAdvisorCitizen">Iniciar sesión</a>
                <a class="link" [routerLink]="'/pages/auth/login/advisor-citizen'" *ngIf="isAdvisorCitizen">Iniciar sesión</a>
            </div>
        </div>
    </div>
</div>